import { apiCall } from './gqlClient';
const GENERATEPAYMENTINTENT_QUERY = "\n  query generatePaymentIntent($productId: String, $reservationId: Int, $subscriptionId: Int, $email: String, $membershipId: Int, $quantity: Int, $startTime: DateTime, $firstname: String, $lastname: String, $phone: String, $bundleId: String) {\n    generatePaymentIntent(productId: $productId, reservationId: $reservationId, subscriptionId: $subscriptionId, email: $email, membershipId: $membershipId, quantity: $quantity, startTime: $startTime, firstname: $firstname, lastname: $lastname, phone: $phone, bundleId: $bundleId)\n    {\n      id\n\t\t\tmessage\n\t\t\tsuccess\n\t\t\tamount\n\t\t\tamountCents\n\t\t\tclientSecret\n\t\t\tstripeAccount\n\t\t\tofferId\n\t\t\tproductId\n      ...fragments\n    }\n  }";
export const generatePaymentIntentApiCall = async function (_ref) {
  let {
    productId,
    reservationId,
    subscriptionId,
    email,
    membershipId,
    quantity,
    startTime,
    firstname,
    lastname,
    phone,
    bundleId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GENERATEPAYMENTINTENT_QUERY,
    variables: {
      productId,
      reservationId,
      subscriptionId,
      email,
      membershipId,
      quantity,
      startTime,
      firstname,
      lastname,
      phone,
      bundleId
    },
    fragments
  });
};
const GENERATEWIDGETPAYMENTINTENT_QUERY = "\n  query generateWidgetPaymentIntent($productId: String, $reservationId: Int, $subscriptionId: Int, $email: String, $membershipId: Int, $quantity: Int, $startTime: DateTime, $firstname: String, $lastname: String, $phone: String, $bundleId: String) {\n    generateWidgetPaymentIntent(productId: $productId, reservationId: $reservationId, subscriptionId: $subscriptionId, email: $email, membershipId: $membershipId, quantity: $quantity, startTime: $startTime, firstname: $firstname, lastname: $lastname, phone: $phone, bundleId: $bundleId)\n    {\n      id\n\t\t\tmessage\n\t\t\tsuccess\n\t\t\tamount\n\t\t\tamountCents\n\t\t\tclientSecret\n\t\t\tstripeAccount\n\t\t\tofferId\n\t\t\tproductId\n      ...fragments\n    }\n  }";
export const generateWidgetPaymentIntentApiCall = async function (_ref2) {
  let {
    productId,
    reservationId,
    subscriptionId,
    email,
    membershipId,
    quantity,
    startTime,
    firstname,
    lastname,
    phone,
    bundleId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GENERATEWIDGETPAYMENTINTENT_QUERY,
    variables: {
      productId,
      reservationId,
      subscriptionId,
      email,
      membershipId,
      quantity,
      startTime,
      firstname,
      lastname,
      phone,
      bundleId
    },
    fragments
  });
};
const GETMYSETUPINTENTSFORPROVIDER_QUERY = "\n  query getMySetupIntentsForProvider($providerId: Int!) {\n    getMySetupIntentsForProvider(providerId: $providerId)\n  }";
export const getMySetupIntentsForProviderApiCall = async _ref3 => {
  let {
    providerId
  } = _ref3;
  return apiCall({
    query: GETMYSETUPINTENTSFORPROVIDER_QUERY,
    variables: {
      providerId
    }
  });
};
const GETMYPAYMENTMETHODSFORPROVIDER_QUERY = "\n  query getMyPaymentMethodsForProvider($providerId: Int!) {\n    getMyPaymentMethodsForProvider(providerId: $providerId)\n    {\n      id\n      ...fragments\n    }\n  }";
export const getMyPaymentMethodsForProviderApiCall = async function (_ref4) {
  let {
    providerId
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETMYPAYMENTMETHODSFORPROVIDER_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETCUSTOMERSPAYMENTPROVIDERS_QUERY = "\n  query getCustomersPaymentProviders {\n    getCustomersPaymentProviders\n    {\n      id\n\t\t\tcityId\n\t\t\tname\n\t\t\ttype\n\t\t\tdescription\n\t\t\taddress\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\tphone\n\t\t\tlatitude\n\t\t\tlongitude\n\t\t\tacceptPayments\n\t\t\tonlineDiscount\n\t\t\ttime\n\t\t\ttimeNote\n\t\t\ttags\n\t\t\turl\n\t\t\tblog\n\t\t\tfacebook\n\t\t\ttwitter\n\t\t\tlinkedin\n\t\t\tskype\n\t\t\tinstagram\n\t\t\tyoutube\n\t\t\temail\n\t\t\trole\n\t\t\tcreated\n\t\t\tactive\n\t\t\tsubscribed\n\t\t\tuserHasMembership\n\t\t\tmembershipsCounter\n\t\t\tfreeCancellationHours\n\t\t\treservationOffset\n\t\t\thasConnectedPaymentAccount\n\t\t\tdefaultTimeSlotStep\n\t\t\tlanguage\n\t\t\townerId\n\t\t\tlocked\n\t\t\tfree\n\t\t\tordersNumber\n\t\t\tnotificationEmail\n\t\t\tappName\n\t\t\tclientProvider\n\t\t\ttimezone\n\t\t\tcanUnlock\n\t\t\tjoinPolicy\n\t\t\tapprovalMethod\n      ...fragments\n    }\n  }";
export const getCustomersPaymentProvidersApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETCUSTOMERSPAYMENTPROVIDERS_QUERY,
    variables: {},
    fragments
  });
};
const CREATESETUPINTENTFORPROVIDER_QUERY = "\n  mutation createSetupIntentForProvider($providerId: Int!, $paymentMethod: String!) {\n    createSetupIntentForProvider(providerId: $providerId, paymentMethod: $paymentMethod)\n    {\n      id\n\t\t\tmessage\n\t\t\tsuccess\n\t\t\tclientSecret\n\t\t\tstripeAccount\n      ...fragments\n    }\n  }";
export const createSetupIntentForProviderApiCall = async function (_ref5) {
  let {
    providerId,
    paymentMethod
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATESETUPINTENTFORPROVIDER_QUERY,
    variables: {
      providerId,
      paymentMethod
    },
    fragments
  });
};
const DELETEPAYMENTMETHOD_QUERY = "\n  mutation deletePaymentMethod($providerId: Int!, $paymentMethod: String!) {\n    deletePaymentMethod(providerId: $providerId, paymentMethod: $paymentMethod)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n      ...fragments\n    }\n  }";
export const deletePaymentMethodApiCall = async function (_ref6) {
  let {
    providerId,
    paymentMethod
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEPAYMENTMETHOD_QUERY,
    variables: {
      providerId,
      paymentMethod
    },
    fragments
  });
};
const CREATESTRIPECUSTOMER_QUERY = "\n  mutation createStripeCustomer {\n    createStripeCustomer\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n      ...fragments\n    }\n  }";
export const createStripeCustomerApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: CREATESTRIPECUSTOMER_QUERY,
    variables: {},
    fragments
  });
};
const GENERATEB2BSUBSCRIPTION_QUERY = "\n  mutation generateB2bSubscription($paymentMethodId: String!, $customerId: String!, $planId: String!, $promoCode: String) {\n    generateB2bSubscription(paymentMethodId: $paymentMethodId, customerId: $customerId, planId: $planId, promoCode: $promoCode)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const generateB2bSubscriptionApiCall = async function (_ref7) {
  let {
    paymentMethodId,
    customerId,
    planId,
    promoCode
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GENERATEB2BSUBSCRIPTION_QUERY,
    variables: {
      paymentMethodId,
      customerId,
      planId,
      promoCode
    },
    fragments
  });
};
const CANCELB2BSUBSCRIPTION_QUERY = "\n  mutation cancelB2bSubscription {\n    cancelB2bSubscription\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const cancelB2bSubscriptionApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: CANCELB2BSUBSCRIPTION_QUERY,
    variables: {},
    fragments
  });
};
const LINKCONNECTEDPAYMENTACCOUNT_QUERY = "\n  mutation linkConnectedPaymentAccount($code: String!) {\n    linkConnectedPaymentAccount(code: $code)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const linkConnectedPaymentAccountApiCall = async function (_ref8) {
  let {
    code
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: LINKCONNECTEDPAYMENTACCOUNT_QUERY,
    variables: {
      code
    },
    fragments
  });
};
const UNLINKCONNECTEDPAYMENTACCOUNT_QUERY = "\n  mutation unlinkConnectedPaymentAccount {\n    unlinkConnectedPaymentAccount\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const unlinkConnectedPaymentAccountApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: UNLINKCONNECTEDPAYMENTACCOUNT_QUERY,
    variables: {},
    fragments
  });
};
const SAVEPAYMENTGATEWAYCUSTOMER_QUERY = "\n  mutation savePaymentGatewayCustomer($request: PaymentGatewayCustomerInput!) {\n    savePaymentGatewayCustomer(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const savePaymentGatewayCustomerApiCall = async function (_ref9) {
  let {
    request
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEPAYMENTGATEWAYCUSTOMER_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const VALIDATEPROMOCODE_QUERY = "\n  mutation validatePromoCode($promoCode: String!, $planId: String!) {\n    validatePromoCode(promoCode: $promoCode, planId: $planId)\n    {\n      promoCode\n\t\t\tisValid\n\t\t\tduration\n\t\t\tdurationInMonths\n\t\t\tfixedDiscount\n\t\t\tpercentDiscount\n\t\t\ttotal\n\t\t\ttotalWithDiscount\n      ...fragments\n    }\n  }";
export const validatePromoCodeApiCall = async function (_ref0) {
  let {
    promoCode,
    planId
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: VALIDATEPROMOCODE_QUERY,
    variables: {
      promoCode,
      planId
    },
    fragments
  });
};
const UPDATESUBSCRIPTIONPROMOCODE_QUERY = "\n  mutation updateSubscriptionPromoCode($promoCode: String!) {\n    updateSubscriptionPromoCode(promoCode: $promoCode)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateSubscriptionPromoCodeApiCall = async function (_ref1) {
  let {
    promoCode
  } = _ref1;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATESUBSCRIPTIONPROMOCODE_QUERY,
    variables: {
      promoCode
    },
    fragments
  });
};
const CHANGEB2BSUBSCRIPTIONPLAN_QUERY = "\n  mutation changeB2bSubscriptionPlan($planId: String!) {\n    changeB2bSubscriptionPlan(planId: $planId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const changeB2bSubscriptionPlanApiCall = async function (_ref10) {
  let {
    planId
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEB2BSUBSCRIPTIONPLAN_QUERY,
    variables: {
      planId
    },
    fragments
  });
};